const apiUrl = "/api/<action>/";
const apiKey = "7D700138A0EA40349E799EA216BF82F9";
const requestTimeoutMs = 15000;

// api interaction
export const apiRequest = (action, params, download) => {
	let url = apiUrl.replace(/<action>/, action);
	const method = ["auth", "bookmark"].indexOf(action) >= 0 ? "POST" : "GET";
	params.api_key = apiKey;

	const cleanedParams = Object.entries(params).filter(([_, value]) => value != null);

	let queryParams = new URLSearchParams(cleanedParams);
	const options = {
		method,
        cache: "force-cache",
		signal: AbortSignal.timeout(requestTimeoutMs),
	};

	if (options.method === "GET") {
		url += `?${queryParams.toString()}`;
        if (download) {
            window.location = url;
            return;
        }
	} else {
		options.body = queryParams;
	}

	return fetch(url, options).then((response) => {
		return response.json();
	});
};

